import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { fromJS } from "immutable";
import { condition } from "MODULES/SalesOrders/constants";
import {
  DetailTable,
  Detail,
  CheckForDetail,
  SpecialInstructions
} from "MODULES/shared/components/DetailTable";
import { shortDateAndTimestamp } from "LIB/formatters/date";
import { RECORD_TYPES } from "MODULES/OutgoingShipments/constants";
import { CARRIERS } from "MODULES/shared/constants";
import { CompanyName, LocationFlag, Section } from "MODULES/shared/components";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import Dimensions from "MODULES/parts/components/Search/Dimensions";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import { Col } from "react-bootstrap";
import EditForm from "./EditShipmentForm";

export default function Panel({ shipment = {} }) {
  const shippingMethod = shipment.shipping_method || {};

  const refId = shipment.reference_record_uuid || shipment.reference_record_id;
  const refs = {
    ReturnedCore: "purchase-orders",
    MistakeShipment: "mistake-shipments",
    PurchaseOrder: "purchase-orders",
    RepairOrder: "repair-orders",
    Rma: "rmas",
    SalesOrder: "sales-orders"
  };

  const carrier = shippingMethod.carrier && CARRIERS[shippingMethod.carrier];
  const formattedShippingMethod =
    carrier &&
    carrier.shippingMethods[shipment.shipping_method.shipping_method].label;
  const initialValues = {
    read_only_part_number: shipment.part_number,
    read_only_serial_number: shipment.serial_number,
    outgoing_awb_number: shipment.outgoing_awb_number,
    country_of_mfg: shipment.country_of_mfg,
    hazmat: shipment.hazmat,
    length: shipment.length,
    width: shipment.width,
    height: shipment.height,
    weight: shipment.weight,
    bio_hazmat: shipment.bio_hazmat,
    quantity: shipment.quantity,
    discreet: shipment.discreet,
    customer_to_provide_own_paperwork:
      shipment.customer_to_provide_own_paperwork,
    reference_record_line_item_id: shipment.reference_record_line_item_id,
    reference_record_line_item_type: shipment.reference_record_line_item_type,
    shipping_method: {
      carrier: shippingMethod.carrier,
      shipping_method: shippingMethod.shipping_method,
      account_number: shippingMethod.account_number
    },
    weight_unit: "lb",
    send_shipment_updated_email: true
  };
  const isIto = shipment.reference_record_type === "InventoryTransferOrder";

  return (
    <Col md={3}>
      <div className="panel panel-default">
        <div className="panel-body">
          <Section
            title="Shipment Details"
            modal={{
              title: "Edit Shipping Details",
              content: close => (
                <EditForm
                  initialValues={initialValues}
                  close={close}
                  shipment={shipment}
                  shippingRecord={shipment}
                  isIto={isIto}
                />
              )
            }}
            editable={
              !shipment.cancelled &&
              shipment.reference_record_line_item_type !== "MistakeShipment"
            }
          >
            <DetailTable>
              <tr>
                <th className="text-right">Customer</th>
                <td>
                  <CompanyName company={shipment.company} />
                </td>
              </tr>
              <Detail
                label="Shipment Type"
                value={RECORD_TYPES[shipment.reference_record_type]}
              />
              <MultiLocationFeature>
                <Detail
                  label={"Store Loc"}
                  value={
                    <LocationFlag
                      location={get(shipment, "inventory.store_owner_id")}
                    />
                  }
                />
              </MultiLocationFeature>
              <tr>
                <th className="text-right">Dimensions</th>
                <Dimensions part={shipment} />
              </tr>
              <tr>
                <th className="text-right">Weight</th>
                <td>{shipment.weight || "N/A"} lb</td>
              </tr>
              <tr>
                <th className="text-right">Ref #</th>
                <td>
                  <Link
                    to={`/${refs[shipment.reference_record_type]}/${refId}`}
                  >
                    {shipment.reference_record_code}
                  </Link>
                </td>
              </tr>
              <tr>
                <th className="text-right">Cust PO#</th>
                <td>{shipment.customer_po}</td>
              </tr>
              <Detail label="Out. AWB #" value={shipment.outgoing_awb_number} />
              {get(shipment, "company.phone") && (
                <tr>
                  <th className="text-right">Customer Ph#</th>
                  <td>{shipment.company.phone}</td>
                </tr>
              )}
            </DetailTable>
            <hr className="hr-xs hr-dashed" />
            <DetailTable>
              <Detail
                label="Created By"
                value={shipment.created_by.full_name}
              />
              <Detail
                label="Checked By"
                value={shipment.checked_by_full_name}
              />
              <Detail
                label="Checked At"
                value={shortDateAndTimestamp(shipment.checked_at)}
              />
            </DetailTable>
            <hr className="hr-xs hr-dashed" />
            <DetailTable>
              <Detail
                label="Condition"
                value={condition(shipment.condition).label}
              />
              <Detail label="Qty. Ship." value={shipment.quantity_shipped} />
              <CheckForDetail
                label="Discreet"
                value={shipment.discreet}
                icon="eye-slash"
              />
              <SpecialInstructions note={shipment.special_instructions} />
              <CheckForDetail
                label="Cust P/W"
                value={shipment.customer_to_provide_own_paperwork}
              />
            </DetailTable>
            <hr className="hr-xs hr-dashed" />
            <ShippingAddress
              shippingType={"ship_to"}
              record={fromJS(shipment)}
              renderPreferences={false}
            />
            <DetailTable>
              <Detail label="Carrier" value={carrier && carrier.label} />
              <Detail label="Method" value={formattedShippingMethod} />
              <Detail
                label="Account Number"
                value={
                  shipment.shipping_method &&
                  shipment.shipping_method.account_number
                }
              />
            </DetailTable>
          </Section>
        </div>
      </div>
    </Col>
  );
}

Panel.propTypes = {
  shipment: T.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Panel/Panel.jsx